import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'

const TOOLS: Array<string> = [
    "Windows",
    "Microsoft Word",
    "Excel",
    "PowerPoint",
    "Outlook",
    "Google Docs",
    "Google Sheets",
    "Canva",
    "Photoshop",
    "HTML",
    "CSS",
    "JavaScript",
    "Python",
    "VS Code",
    "Zoom"
]

export const ToolsMarquee: FC = (): ReactNode => {
    return (
        <section id='tools' aria-labelledby='tools-title' className='border-y bg-card'>
            <Container className='flex flex-col gap-4 py-6 md:flex-row md:items-center md:gap-10'>
                <h2 id='tools-title' className='shrink-0 font-mono text-xs font-medium tracking-wider text-muted-foreground uppercase'>
                    Software you will use
                </h2>

                <div className='relative min-w-0 flex-1 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]'>
                    <ul className='flex w-max animate-marquee gap-3 pr-3 hover:[animation-play-state:paused] motion-reduce:animate-none'>
                        {[...TOOLS, ...TOOLS].map((tool, index) => (
                            <li
                                key={`${tool}-${index}`}
                                aria-hidden={index >= TOOLS.length ? 'true' : undefined}
                                className='inline-flex items-center gap-2 rounded-full border bg-background px-4 py-2 font-mono text-sm whitespace-nowrap text-foreground/80'
                            >
                                <span className='size-1.5 rounded-full bg-primary' aria-hidden='true' />
                                {tool}
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </section>
    )
}
